import axios from "axios";
import { logger } from "../utils/logger";
import { API_BASE } from "../utils/apiBase.js";

const authService = {
  login: async ({ email, password }) => {
  logger.debug("authService login attempt", { email });
    const response = await axios.post(`${API_BASE}/auth/login`, {
      email,
      password,
    });
  logger.debug("authService login response", response.data);
    return response.data;
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    const token = localStorage.getItem("token");
  logger.debug("authService changePassword token prefix", token?.slice(0, 12) + "...");
    const response = await axios.post(
      `${API_BASE}/auth/change-password`,
      { currentPassword, newPassword },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
  logger.debug("authService changePassword response", response.data);
    return response.data;
  },

  changeEmail: async ({ newEmail, password }) => {
    const token = localStorage.getItem("token");
  logger.debug("authService changeEmail token prefix", token?.slice(0, 12) + "...");
    const response = await axios.post(
      `${API_BASE}/auth/change-email`,
      { newEmail, password },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
  logger.debug("authService changeEmail response", response.data);
    return response.data;
  },

  status: async () => {
    const token = localStorage.getItem("token");
  logger.debug("authService status token prefix", token?.slice(0, 12) + "...");
    const response = await axios.get(`${API_BASE}/auth/status`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  logger.debug("authService status response", response.data);
    return response.data;
  },

  logout: async () => {
    try {
      const token = localStorage.getItem("token");

      // If there's no token, skip network call and just clear local state
      if (!token) {
        localStorage.removeItem("token");
        localStorage.removeItem("userOn");
        return { message: "Logged out locally" };
      }

      // Make logout request
      const response = await axios.post(`${API_BASE}/auth/logout`, {}, {
        withCredentials: true,
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      // Clear localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("userOn");

      return response.data;
  } catch {
      // Still clear localStorage even if request fails
      localStorage.removeItem("token");
      localStorage.removeItem("userOn");
      // Resolve gracefully so UI can proceed without refresh
      return { message: "Logged out locally" };
    }
  },
};

export default authService;
